import { arrayToKeyValuePairs } from 'shared/utils';
import { ReimbursementType } from 'types/underwriting/income-approach';

export const Labels = {
  TENANT_NAME: 'Tenant',
  BASE_YEAR: 'Base Year',
  CURRENT_YEAR_LIABILITY: 'Current Year Liability',
  BASE_YEAR_ASSESMENT: 'Base Year Assessment ($)',
  BASE_YEAR_TAX_RATE: 'Base Year Tax Rate',
  BASE_YEAR_LIABILITY: 'Base Year Liability',
  INCREASE: 'Increase',
  REIMBURSEMENT_SHARE: 'Reimbursement Share (%)',
  ANNUAL_REIMBURSEMENT: 'Annual Reimbursement',
};

export const REIMBURSEMENT_TYPES: { [key in ReimbursementType]: { value: string; label: string } } = {
  increaseOverBaseYear: { value: 'increaseOverBaseYear', label: 'Increase Over Base Year' },
  dollarAmount: { value: 'dollarAmount', label: 'Dollar Amount' },
  percentOfCurrentYearLiability: { value: 'percentOfCurrentYearLiability', label: '% of Current Year Liability' },
  percentOfForecast: { value: 'percentOfForecast', label: '% of Forecast' },
};

export const TAX_REIMBURSEMENT_TYPE_OPTIONS = [
  // REIMBURSEMENT_TYPES.increaseOverBaseYear,
  REIMBURSEMENT_TYPES.percentOfCurrentYearLiability,
  REIMBURSEMENT_TYPES.dollarAmount,
];
export const OTHER_REIMBURSEMENT_TYPE_OPTIONS = [
  REIMBURSEMENT_TYPES.percentOfForecast,
  REIMBURSEMENT_TYPES.dollarAmount,
];

export const DOLLAR_AMOUNT_TYPE_OPTIONS = arrayToKeyValuePairs(['Monthly', 'Annual'], true);
export const BASE_YEAR_VALUE_TYPE_OPTIONS = arrayToKeyValuePairs(['Base Year Assessment', 'Base Year Liability'], true);
